module.exports = __webpack_public_path__ + "img/logo_ey.fa04464d.png";